import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import Located from "@mapmycustomers/shared/types/base/Located";

import PinPopover from "@app/scene/map/components/PinPopover";
import { selectMapTool, updatePinDropCoordinates } from "@app/scene/map/store/actions";
import { getMapPinDrop } from "@app/scene/map/store/selectors";
import PinDropModel from "@app/scene/map/types/PinDropModel";
import { RootState } from "@app/store/rootReducer";

interface Props {
  onCreateCompany: (location: Located | undefined) => void;
  onCreatePerson: (location: Located | undefined) => void;
  pinDrop?: PinDropModel;
  selectMapTool: typeof selectMapTool;
  updatePinDropCoordinates: typeof updatePinDropCoordinates.request;
}

const DropPinAnnotation: React.FC<Props> = ({
  onCreateCompany,
  onCreatePerson,
  pinDrop,
  selectMapTool,
  updatePinDropCoordinates,
}) => {
  const intl = useIntl();

  const coordinates = pinDrop?.coordinates;

  const handleCancel = useCallback(() => {
    updatePinDropCoordinates(undefined);
    selectMapTool(undefined);
  }, [selectMapTool, updatePinDropCoordinates]);

  const handleMenuItemClick = useCallback(() => {
    updatePinDropCoordinates(undefined);
    selectMapTool(undefined);
  }, [selectMapTool, updatePinDropCoordinates]);

  const handleCreateCompany = useCallback(() => {
    onCreateCompany(pinDrop?.address);
  }, [onCreateCompany, pinDrop?.address]);

  const handleCreatePerson = useCallback(() => {
    onCreatePerson(pinDrop?.address);
  }, [onCreatePerson, pinDrop?.address]);

  return (
    <PinPopover
      address={pinDrop?.address}
      coordinates={pinDrop?.coordinates}
      loading={!!pinDrop?.loading}
      onCancel={handleCancel}
      onCreateCompany={handleCreateCompany}
      onCreatePerson={handleCreatePerson}
      onMenuItemClick={handleMenuItemClick}
      title={intl.formatMessage({
        id: "map.tool.dropPin.annotation.title",
        defaultMessage: "Dropped Pin",
        description: "Drop Pin Annotation Popover Title",
      })}
      visible={coordinates && pinDrop?.visible}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  pinDrop: getMapPinDrop(state),
});

const mapDispatchToProps = {
  selectMapTool,
  updatePinDropCoordinates: updatePinDropCoordinates.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(DropPinAnnotation);
